import { AloftPrice, isDefined, schAlertType, schPairedCostRouteItem } from '@aloft/toolkit-shared';

import { AlertDefinition } from '../../types.ts';
import { getCompTypeLabel, getScopedAlertType } from '../utils/compTypeScoping.ts';

export const allCompsAdjustedUp: AlertDefinition = ({
  compAdjustments,
  compSequence,
  compType,
  order,
}) => {
  if (
    compSequence.length < 2 ||
    !compSequence
      .map((id) => compAdjustments[id]?.netAdjustment.adjustment)
      .filter(isDefined)
      .every((netAdjustment) => netAdjustment.gt(AloftPrice.zero))
  ) {
    return undefined;
  }

  let message: string;
  switch (compType) {
    case 'aiv':
    case 'arv':
      message = `All ${getCompTypeLabel(compType)} Comparables are net adjusted up.`;
      break;
    default:
      message = 'All Comparables are net adjusted up.';
      break;
  }

  return {
    type: getScopedAlertType(schAlertType.enum.allCompsAdjustedUp, compType),
    status: 'active',
    message,
    ...(compType ? { compType } : {}),
    fixingInfo: {
      tips: 'Tips: Having all comparables adjusted in the same direction can be an indication of systematic bias in comparable selection. Adjustments should go in different directions and roughly offset each other.',
      pairedCostRouteItem:
        schPairedCostRouteItem.enum[order.isInspectifyOrder ? 'adjustments-grid' : 'adjustments'],
    },
  };
};
